interface ToastProps {
  message: string;
}

export default function Toast({ message }: ToastProps) {
  const visible = Boolean(message);
  return (
    <div
      className={`fixed bottom-6 left-1/2 z-50 -translate-x-1/2 transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
      aria-live="polite"
    >
      <div className="flex items-center gap-2 rounded-full border border-foreground-800 bg-foreground-950 px-5 py-2.5 text-sm text-background-50">
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-checkbox-circle-fill text-accent-400"></i>
        </span>
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}